module.exports = __webpack_public_path__ + "images/emoji/calendar.3b0fbe41a096ff8ec5aa.png";